import './libs/globals'

// Lorsque le document est prêt, mais tout n'est pas encore loadé ou affiché

$(document).ready(function () {
  $('.hamburger').click(function (e) {
    e.preventDefault();
    $('header .menu-menu-principal-container').slideToggle();
    $(this).toggleClass('active');
    $('main').toggleClass('off');
  })
});

// Après que les images soient loadés
$(window).on('load', function () {

});


// WEBPACK FOOTER //
// ./wp-content/themes/obc/js/main.js